export default __webpack_public_path__ + "static/media/whatCard4.a76abdd6.webp";